import React from "react";

const Loading = () => {
  return (
    <div className="hero min-h-screen">
      <div className="hero-content text-center">
        <div className="max-w-md">
          <span className="loading loading-infinity w-16"></span>
        </div>
      </div>
    </div>
  );
};

export default Loading;
